/* Attrapez les tous ! — pop-up de bienvenue (e-mail contre un bon de première commande).
   Le code n'apparaît qu'après une inscription réussie (rendu côté Shopify), puis il est appliqué
   au panier par /discount/CODE et le tiroir panier est rafraîchi. */
(function () {
  'use strict';
  var pop = document.getElementById('atl-pop');
  if (!pop || window.ATL_POP_READY) return;
  window.ATL_POP_READY = true;

  var KEY = 'atl-pop';
  var state = pop.dataset.state;
  var code = pop.dataset.code;
  var delay = Math.max(0, parseInt(pop.dataset.delay, 10) || 12) * 1000;
  var days = Math.max(1, parseInt(pop.dataset.days, 10) || 14);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function read() { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
  function write(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }

  var lastFocus = null;
  function open() {
    if (!pop.hidden) return;
    lastFocus = document.activeElement;
    pop.hidden = false;
    requestAnimationFrame(function () { pop.classList.add('is-open'); });
    document.documentElement.classList.add('atl-pop-open');
    var f = pop.querySelector('input[type="email"], .atl-pop__submit');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 60);
  }
  function close() {
    pop.classList.remove('is-open');
    document.documentElement.classList.remove('atl-pop-open');
    setTimeout(function () { pop.hidden = true; }, 220);
    var s = read();
    if (state !== 'done') { s.closed = Date.now(); write(s); }
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  pop.addEventListener('click', function (e) {
    if (e.target.closest('[data-pop-close]')) { e.preventDefault(); close(); }
    var c = e.target.closest('[data-pop-copy]');
    if (c && navigator.clipboard) {
      navigator.clipboard.writeText(code).then(function () { c.textContent = 'Copié'; setTimeout(function () { c.textContent = 'Copier'; }, 1600); });
    }
  });
  pop.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') { /* piège de focus dans la carte */
      var f = pop.querySelectorAll('button, input, a[href]');
      var list = [].filter.call(f, function (n) { return !n.disabled && n.offsetParent !== null; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Inscription réussie : appliquer le code au panier (il apparaît au paiement et sur la page panier),
     sans ouvrir le tiroir panier, et ne plus jamais afficher le pop-up */
  function applyCode() {
    return fetch(root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart.js'), { credentials: 'same-origin' })
      .then(function () {
        var ok = pop.querySelector('[data-pop-applied]');
        if (ok) ok.hidden = false;
        write({ done: Date.now(), code: code });
      })
      .catch(function () { write({ done: Date.now(), code: code }); });
  }

  if (state === 'done' || state === 'error') {
    if (state === 'done') applyCode();
    open();
    if (history.replaceState && /customer_posted/.test(location.search)) {
      history.replaceState(null, '', location.pathname + location.hash.replace('#atl-pop-form', ''));
    }
    return;
  }

  /* Quand l'afficher : pas sur le panier, le compte ni le paiement ; pas si déjà inscrit ;
     pas avant N jours après une fermeture ; jamais par-dessus le bandeau cookies. */
  var s = read();
  if (s.done) return;
  if (s.closed && Date.now() - s.closed < days * 864e5) return;
  if (/^\/(cart|account|checkout|challenge|password)/.test(location.pathname.replace(root, '/'))) return;
  if (window.Shopify && Shopify.designMode) return;

  var armed = false;
  function trigger() {
    if (armed) return;
    if (document.documentElement.classList.contains('atl-cookie-open') || window.ATL_CONSENT_PENDING) {
      document.addEventListener('atl:consent-closed', function once() {
        document.removeEventListener('atl:consent-closed', once);
        setTimeout(trigger, 1500);
      });
      return;
    }
    armed = true;
    open();
  }
  setTimeout(trigger, delay);
  /* intention de sortie sur ordinateur */
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0 && window.matchMedia('(pointer: fine)').matches) trigger();
  });
})();
